import { useEffect } from "react";
import monday from "monday-sdk-js";

/**
 * Keeps `<html>` in sync with monday.com Item View `context.theme`.
 * Palettes are driven by CSS variables in `monday-host-theme.css` and Tailwind.
 * @see https://style.monday.com/
 */
export function useMondayTheme(): void {
  useEffect(() => {
    const client = monday();

    function apply(theme: unknown): void {
      const html = document.documentElement;
      const t = typeof theme === "string" ? theme.toLowerCase() : "light";
      html.dataset.mondayTheme = t;
      html.classList.remove(
        "monday-theme-dark",
        "monday-theme-black",
        "monday-theme-hacker"
      );
      if (t === "dark") html.classList.add("monday-theme-dark");
      else if (t === "black") html.classList.add("monday-theme-black");
      else if (t === "hacker") html.classList.add("monday-theme-hacker");
    }

    client
      .get("context")
      .then((res: { data?: { theme?: string } }) => apply(res?.data?.theme))
      .catch(() => apply("light"));

    const unsub = client.listen(
      "context",
      (res: { data?: { theme?: string } }) => {
        apply(res?.data?.theme);
      }
    );

    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, []);
}
